import { render, staticRenderFns } from "./CxpCargoFormComponent.vue?vue&type=template&id=1c10c51c&"
import script from "./CxpCargoFormComponent.vue?vue&type=script&lang=js&"
export * from "./CxpCargoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports